import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Button,
  Form,
  Icon,
  Modal,
  Checkbox,
  FormField,
  Dropdown,
} from 'semantic-ui-react'
// import { capitalize } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import styles from './asset-modal.module.css'
import StatusDialog from '../../../status-dialog'
import IntelMsg from '../../../ItelMsg/index'
import {
  GetCustomerAssetsList,
  GetCustomerAssetTypes,
  saveAsset,
  GetUserCustomers,
} from '../../../../services/asset'
import {
  aryIannaTimeZones,
  drugs,
  medical,
  food,
  plateTypes,
  fodder,
  pesticides,
} from './arraies'
import {
  GetAssetCreationTemplate,
  GetsfdaStorageTypes,
} from '../../../../services/configuration-template/index'
import { RefreshCustomerAssetList } from '../../../../redux/actions/asset'
import ValidatorGenerator from '../../../../services/configuration-template/validatores'

const AddAsset = ({ show, setShow }) => {
  const { register, errors, handleSubmit, clearErrors, setValue } = useForm()
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [showStatusDialog, setShowStatusDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState(<></>)
  const [creationData, setCreationData] = useState([])
  const [storageCode, setStorageCode] = useState([])

  const [allAssets, setAllAssets] = useState([])
  const [storageTypes, setStorageTypes] = useState([])
  const [storageIsEmpty, setStorageIsEmpty] = useState(false)
  const [codeIsEmpty, setCodeIsEmpty] = useState(true)
  const [zoneId, setZoneID] = useState()
  const [zoneEmpty, setZoneEmpty] = useState(true)

  const [assetCustAttributes, setAssetCustAttributes] = useState([])
  const [storageFlag, setStorageFlag] = useState(true)
  const [codeFlag, setCodeFlag] = useState(false)
  const [plateTypeISEmpty, setPlateTypeISEmpty] = useState(true)
  const [selectedPlateType, setSetSelectedPlateType] = useState()
  const [selectedAssetType, setSelectedAssetType] = useState()
  const [selectedStorage, setSelectedStorage] = useState()
  const [customersList, setCustomersList] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState('')
  const dispatch = useDispatch()
  const [assetsRefList, setAssetRefList] = useState([])
  const [devicesRefList, setDeviceRefList] = useState([])
  const [gatewayRefList, setGatewayRefList] = useState([])
  const [selectedFile, setSelectedFile] = useState()
  const [photo, setPhoto] = useState()

  const cosmetics = [{ value: 'Room Temperature', text: 'Room Temperature' }]

  const [codeList, setCodeList] = useState([])
  const { t } = useTranslation()
  const productName = localStorage.getItem('product')
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  useEffect(() => {
    console.log('selectedStorage', selectedStorage)
    if (selectedStorage === 'DRUGS') {
      setCodeList(drugs)
    }
    if (selectedStorage === 'COSMETICS') {
      setCodeList(cosmetics)
    }
    if (selectedStorage === 'MEDICAL') {
      setCodeList(medical)
    }
    if (selectedStorage === 'FOOD') {
      setCodeList(food)
    }
    if (selectedStorage === 'FODDER') {
      setCodeList(fodder)
    }
    if (selectedStorage === 'PESTICIDES') {
      setCodeList(pesticides)
    }
  }, [selectedStorage])
  useEffect(() => {
    if (selectedAssetType && selectedCustomer) {
      setCreationData()
      GetAssetCreationTemplate(productName, selectedAssetType, userEmail).then(
        (configData) => {
          console.log('conf: ', configData)
          if (configData.creationMap) {
            const creationMap = JSON.parse(configData.creationMap)
            console.log('map  : ', creationMap)
            creationMap.sort(sorting)
            setCreationData(creationMap)
          }

          if (configData.assetCustomAttributesMap) {
            const custAttr = JSON.parse(configData.assetCustomAttributesMap)
            custAttr.sort(sorting)
            setAssetCustAttributes(custAttr)
            console.log('custAttr', custAttr)
          } else {
            setAssetCustAttributes([])
          }

          // setCountries()
        },
      )
    }
  }, [selectedAssetType])

  useEffect(() => {
    if (!selectedFile) {
      setPhoto(undefined)
      return
    }
    const reader = new FileReader()
    reader.addEventListener(
      'load',
      function () {
        setPhoto(reader.result)
      },
      false,
    )
    if (selectedFile) {
      reader.readAsDataURL(selectedFile)
    }
  }, [selectedFile])

  useEffect(() => {
    if (show) {
      const customerData = []
      GetUserCustomers(userEmail, productName).then((customers) => {
        customers.forEach((customer) => {
          customerData.push({
            text: customer.title,
            value: customer.tbCustomerId,
          })
        })
        setCustomersList(customerData)
      })
    }
  }, [show])
  useEffect(() => {
    if (selectedCustomer) {
      const Storages = []

      GetsfdaStorageTypes(productName).then((res) => {
        res.forEach((element) => {
          Storages.push({ value: element, text: element })
        })
        setStorageTypes(Storages)
      })
      GetCustomerAssetTypes(userEmail, productName).then((data) => {
        setTimeout(() => {
          data.forEach((asset, idx) => {
            console.log('assetsRefList', assetsRefList)
            if (assetsRefList['Asset Type'])
              assetsRefList['Asset Type'].options[idx] = new Option(
                asset,
                asset,
                false,
                false,
              )
          })
        }, 500)

        GetAssetCreationTemplate(productName, 'ROOM', userEmail).then(
          (configData) => {
            console.log('conf: ', configData)
            const creationMap = JSON.parse(configData.creationMap)
            console.log('roooom  : ', creationMap)
            // const thresholds = JSON.parse(
            //   configData.thresholdsConfigurationAttributes,
            // )
            if (configData.assetCustomAttributesMap) {
              const custAttr = JSON.parse(configData.assetCustomAttributesMap)
              custAttr.sort(sorting)
              setAssetCustAttributes(custAttr)
              console.log('custAttr', custAttr)
            }

            // thresholds.sort(sorting)
            // setThresholdsConfigurationAttributes(thresholds)
            creationMap.sort(sorting)
            setCreationData(creationMap)
          },
        )
      })
    }
  }, [selectedCustomer])

  // const setCountries = () => {
  //   GetCustomerAssetsList(
  //     userEmail,
  //     'country',
  //     productName,
  //     selectedCustomer,
  //   ).then((data) => {
  //     console.log('country', data.data)
  //     allAssets.Country = data.data
  //     devicesRefList.Country.options[0] = new Option(
  //       'Select Country',
  //       -1,
  //       false,
  //       false,
  //     )
  //     setAllAssets(allAssets)
  //     data.data.forEach((asset, idx) => {
  //       assetsRefList.Country.options[idx + 1] = new Option(
  //         asset['asset name'],
  //         asset['asset name'],
  //         false,
  //         false,
  //       )
  //     })
  //   })
  // }
  const sorting = (config1, config2) => {
    if (config1.sort < config2.sort) {
      return -1
    }
    if (config1.sort > config2.sort) {
      return 1
    }
    // a must be equal to b
    return 0
  }
  async function onSubmit(data) {
    console.log('data', data)
    const specialChar = /[\\/.?=&:#]+/g
    if (specialChar.test(data.name)) {
      Swal.fire('Asset Name can not have special characters', '', 'error')
      return
    }
    let content = <></>

    clearErrors()
    if (!storageFlag) {
      content = getDialogContent(false, 'Storage is Missing')
      setDialogContent(content)
      setShowStatusDialog(true)
    } else if (!codeFlag) {
      content = getDialogContent(false, 'Storage Code is Missing')
      setDialogContent(content)
      setShowStatusDialog(true)
    } else if (selectedAssetType === 'Vehicle' && plateTypeISEmpty) {
      content = getDialogContent(false, 'Plate Type is Missing')
      setDialogContent(content)
      setShowStatusDialog(true)
    } else if (codeIsEmpty) {
      content = getDialogContent(false, 'Storage Code is Missing')
      setDialogContent(content)
      setShowStatusDialog(true)
    } else if (selectedAssetType === 'Trackable Vehicle' && zoneEmpty) {
      content = getDialogContent(false, 'Vehicle Zone Id is Missing')
      setDialogContent(content)
      setShowStatusDialog(true)
    } else if (selectedAssetType === 'Non-Trackable Vehicle' && zoneEmpty) {
      content = getDialogContent(false, 'Vehicle Zone Id is Missing')
      setDialogContent(content)
      setShowStatusDialog(true)
    } else {
      console.log('dataa', data)
      const finalData = { ...data, Photo: photo }

      finalData.zoneId = zoneId
      finalData.plateType = selectedPlateType

      try {
        const response = await saveAsset(
          userEmail,
          productName,
          finalData,
          selectedStorage,
          storageCode,
          selectedCustomer,
        )

        if (response.success) {
          setShow(false)
          setCodeFlag(false)
          setStorageIsEmpty(true)
          setPlateTypeISEmpty(true)
          setSelectedCustomer(
            localStorage.setItem('customer', selectedCustomer),
          )
          dispatch(RefreshCustomerAssetList(true))
          setSelectedStorage()
          setDisableSubmit(true)
          content = getDialogContent(
            true,
            response.message ? response.message : 'Asset Added',
          )
          setPhoto(undefined)
          setSelectedFile(undefined)
        } else {
          let { msg } = response
          msg = Array.isArray(msg)
            ? msg.map((error) => <div>{error}</div>)
            : msg
          content = getDialogContent(false, msg || 'Asset Not Added')
        }
        setDialogContent(content)
        setShowStatusDialog(true)

        // setSelectedStorage()
      } catch (e) {
        let { msg } = e
        msg = Array.isArray(msg)
          ? msg.map((error) => (
              <>
                <div>{error}</div>
                <br />
              </>
            ))
          : msg
        setDialogContent(getDialogContent(false, msg || 'Asset Not Added'))
        setShowStatusDialog(true)
        // setShow(false)
      }
    }
  }
  const getDialogContent = (success, msg) => {
    if (success) {
      return (
        <>
          <Icon name="check" size="huge" color="green" />
          <div style={{ fontSize: 'x-large' }}>{msg}</div>
        </>
      )
    }
    return (
      <>
        <Icon name="exclamation triangle" size="huge" color="red" />
        <div style={{ fontSize: 'x-large' }}>{msg}</div>
      </>
    )
  }
  const handleClose = () => {
    setShow(false)
    setCodeFlag(false)
    setSelectedCustomer(localStorage.setItem('customer', selectedCustomer))
    dispatch(RefreshCustomerAssetList(true))
    setStorageIsEmpty(true)
    setPlateTypeISEmpty(true)
    setSelectedStorage()
    setDisableSubmit(true)
    // setStorageCreationData([])
  }
  const createTextField = (columnData) => {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <input
          ref={(ref) => {
            register(ref, { validate })
          }}
          type={columnData['input type'] === 'NUMERIC' ? 'number' : 'text'}
          name={columnData['input name']}
          placeholder={
            columnData.placeholder === 'hh:mm:ss'
              ? columnData.placeholder
              : t(columnData.placeholder)
          }
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }

  function createSelectField(columnData) {
    // return <div>{JSON.stringify(columnData)}</div>
    // setAssetName(columnData['input name'])
    // eslint-disable-next-line array-callback-return
    if (columnData['input name id'] === 'zoneId') {
      return (
        <FormField error={errors[columnData['input name']]}>
          <strong>
            <IntelMsg id={columnData['label ID']} />
          </strong>
          <Dropdown
            className="my-className"
            placeholder="Select Zone"
            fluid
            search
            selection
            ref={(ref) => {
              register(ref, {
                validate: { isValidSelect: (value) => value !== '-1' },
              })
              aryIannaTimeZones.text = ref
            }}
            options={aryIannaTimeZones}
            onChange={(e, data) => {
              setZoneID(data.value)
              setZoneEmpty(false)
            }}
            name={columnData['input name']}
          ></Dropdown>

          <small style={{ color: 'red' }}>
            <IntelMsg id={['**']} />
          </small>

          {/* {columnData['validator type'] !== 'noValidation' ? (
            <small style={{ color: 'red' }}>
              {errors[columnData['input name']] ? (
                <IntelMsg id={columnData['err msg']} />
              ) : (
                '**'
              )}
            </small>
          ) : null} */}
        </FormField>
      )
    }
    if (columnData['input name id'] === 'plateType') {
      return (
        <FormField error={errors[columnData['input name']]}>
          <strong>
            <IntelMsg id={columnData['label ID']} />
          </strong>
          <Dropdown
            className="my-className"
            placeholder="Select Plate Type"
            fluid
            search
            error={plateTypeISEmpty}
            selection
            ref={(ref) => {
              register(ref, {
                validate: { isValidSelect: (value) => value !== '-1' },
              })
              plateTypes.text = ref
            }}
            options={plateTypes}
            onChange={(e, data) => {
              setSetSelectedPlateType(data.value)
              setPlateTypeISEmpty(false)
            }}
            name={columnData['input name']}
          ></Dropdown>

          <small style={{ color: 'red' }}>
            <IntelMsg id={['**']} />
          </small>

          {/* {columnData['validator type'] !== 'noValidation' ? (
            <small style={{ color: 'red' }}>
              {errors[columnData['input name']] ? (
                <IntelMsg id={columnData['err msg']} />
              ) : (
                '**'
              )}
            </small>
          ) : null} */}
        </FormField>
      )
    }
    return (
      <Form.Field
        error={errors[columnData['input name']]}
        onChange={async (e) => {
          if (columnData['input name'] !== 'devices') {
            if (columnData['input name'] === 'assetType') {
              GetAssetCreationTemplate(
                productName,
                e.target.value,
                userEmail,
              ).then((configData) => {
                const creationMap = JSON.parse(configData.creationMap)
                creationMap.sort(sorting)
                setCreationData(creationMap)
                // setCountries()
              })
            } else if (columnData.nextLevel) {
              const newOptions = await GetCustomerAssetsList(
                userEmail,
                columnData.nextLevel,
                productName,
                selectedCustomer,
                columnData['input name'] !== 'assetType'
                  ? e.target.value
                  : null,
              )
              allAssets[columnData.nextLevel] = newOptions.data
              setAllAssets(allAssets)
              console.log('allAssets', allAssets)
              assetsRefList[columnData.nextLevel].options[0] = new Option(
                'Select ',
                -1,
                false,
                false,
              )
              newOptions.data.forEach((asset, idx) => {
                console.log('asset', asset)
                if (assetsRefList[columnData.nextLevel]) {
                  assetsRefList[columnData.nextLevel].options[idx + 1] =
                    new Option(
                      asset['asset name'],
                      asset['asset name'],
                      false,
                      false,
                    )
                }
              })
            }
          }
        }}
      >
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <select
          ref={(ref) => {
            register(ref, {
              validate: { isValidSelect: (value) => value !== '-1' },
            })
            assetsRefList[columnData['header name']] = ref
            setAssetRefList(assetsRefList)
            devicesRefList[columnData['header name']] = ref
            setDeviceRefList(devicesRefList)
            gatewayRefList[columnData['header name']] = ref

            setGatewayRefList(gatewayRefList)
          }}
          name={columnData['input name']}
        >
          <option value={-1}>{t(columnData.placeholder)}</option>
        </select>

        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }

  function createTextArea(columnData) {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <textarea
          ref={register({ validate })}
          name={columnData['input name']}
          rows={3}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }

  function createCheckBox(columnData) {
    register({ name: columnData['input name'], value: false })
    // if(){}
    return (
      <Form.Field>
        {columnData['input name'] === 'Saturday' ? (
          <div style={{ width: '100%' }}>
            {/* <div style={{ width: '100%' }}>
              <label htmlFor>Week Schedule</label>
              <Icon name="calendar alternate outline"></Icon>
            </div> */}
            <div style={{ marginTop: '-15px' }}>
              <label htmlFor>Week Schedule :</label>
              <Checkbox
                style={{ marginTop: '-11px' }}
                label={t(columnData['header name'] || columnData['input name'])}
                name={columnData['input name']}
                onChange={(e, { name, checked }) => {
                  setValue(name, checked)
                }}
              />
            </div>
          </div>
        ) : (
          <div style={{ marginTop: '5px' }}>
            <Checkbox
              label={t(columnData['header name'] || columnData['input name'])}
              name={columnData['input name']}
              onChange={(e, { name, checked }) => {
                setValue(name, checked)
              }}
            />
          </div>
        )}
      </Form.Field>
    )
  }

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined)
      return
    }
    setSelectedFile(e.target.files[0])
  }

  const createPhotoInput = (columnData) => {
    console.log('column data: ', columnData)
    return (
      <>
        <Form.Field>
          <strong>
            <IntelMsg id={columnData['label ID']} />
          </strong>
          <input required type="file" onChange={onSelectFile} />
          <small style={{ color: 'red' }}>**</small>
          <br />
          {(selectedFile || photo) && (
            <img src={photo} alt="img" width="100" height="100" />
          )}
        </Form.Field>
      </>
    )
  }

  function createColumn(columnData) {
    if (columnData['input type'] === 'STRING')
      return createTextField(columnData)
    if (columnData['input type'] === 'SELECT')
      return createSelectField(columnData)
    if (columnData['input type'] === 'TEXT_AREA')
      return createTextArea(columnData)
    if (columnData['input type'] === 'BOOLEAN') {
      return createCheckBox(columnData)
    }
    if (columnData['input type'] === 'PHOTO') {
      return createPhotoInput(columnData)
    }

    return createTextField(columnData)
  }

  return (
    <>
      <div>
        <Modal
          onClose={() => setShow(false)}
          onOpen={() => setShow(true)}
          open={show}
          centered
          style={{ position: 'relative', height: 'auto' }}
        >
          <Modal.Header className={styles.header} closeButton>
            <IntelMsg id="addAssetHeaderModal" />
          </Modal.Header>
          <Modal.Content scrolling>
            <Form
              style={{ overflow: 'visible' }}
              id="deviceAddForm"
              onSubmit={handleSubmit(onSubmit)}
              widths="equal"
            >
              {!selectedCustomer ? (
                // <Segment placeholder>
                //   <Header icon>
                //     <Icon name="address card" />
                //     Please Select Customer
                //   </Header>
                <>
                  <strong>
                    <IntelMsg id="Customers" />
                  </strong>
                  <Dropdown
                    style={{ marginBottom: '25%' }}
                    name="customers"
                    text="Select Customer"
                    options={customersList}
                    placeholder="Select Customer to Create New Asset"
                    defaultValue={selectedCustomer}
                    fluid
                    search
                    selection
                    onChange={async (e, data) => {
                      console.log('e.target.value', data.value)
                      setDisableSubmit(false)
                      setSelectedCustomer(data.value)
                      localStorage.setItem('customer', data.value)
                    }}
                  ></Dropdown>
                </>
              ) : (
                // </Segment>
                <FormField error={errors.facilityTypes}>
                  <strong>
                    <IntelMsg id="Customers" />
                  </strong>
                  <Dropdown
                    name="customers"
                    className="my-className"
                    options={customersList}
                    placeholder="Select Customer to Submit"
                    defaultValue={selectedCustomer}
                    fluid
                    search
                    selection
                    onChange={async (e, data) => {
                      console.log('e.target.value', data.value)
                      setDisableSubmit(false)
                      setSelectedCustomer(data.value)
                      localStorage.setItem('customer', data.value)
                    }}
                  ></Dropdown>
                </FormField>
              )}

              {selectedCustomer ? (
                <>
                  <FormField error={errors.facilityTypes}>
                    <strong>
                      <IntelMsg id="StorageType" />
                    </strong>
                    <Dropdown
                      name="StorageType"
                      className="my-className"
                      options={storageTypes}
                      placeholder="Select Storage type"
                      fluid
                      search
                      selection
                      error={storageIsEmpty}
                      onChange={async (e, data) => {
                        console.log('e.target.value', data.value)
                        setStorageFlag(true)
                        setStorageIsEmpty(false)
                        setCodeFlag(true)
                        setSelectedStorage(data.value)
                      }}
                    ></Dropdown>
                    <small style={{ color: 'red' }}>
                      <IntelMsg id={['**']} />
                    </small>
                  </FormField>
                  <FormField>
                    <strong>
                      <IntelMsg id="StorageCode" />
                    </strong>
                    <Dropdown
                      name="StorageCode"
                      className="my-className"
                      options={codeList}
                      placeholder="You have to select storage code"
                      fluid
                      search
                      selection
                      error={codeIsEmpty}
                      onChange={async (e, data) => {
                        console.log('e.target.value', data.value)
                        setCodeIsEmpty(false)
                        setDisableSubmit(false)
                        setStorageCode(data.value)
                      }}
                    ></Dropdown>

                    <small style={{ color: 'red' }}>
                      <IntelMsg id={['**']} />
                    </small>
                  </FormField>
                  {/* <FormField error={errors.facilityTypes}>
                    
                  </FormField> */}
                  <FormField
                    error={errors.assetType}
                    // onChange={async (e) => {
                    //   console.log(e.target.value)
                    //   GetAssetCreationTemplate(
                    //     productName,
                    //     e.target.value,
                    //     email,
                    //   ).then((configData) => {
                    //     const creationMap = JSON.parse(configData.creationMap)
                    //     const alarmsAttributes = JSON.parse(
                    //       configData.assetAlarmsAttributes,
                    //     )
                    //     console.log('creationMap', creationMap)
                    //     const reportsAttributes = JSON.parse(
                    //       configData.assetReportsAttributes,
                    //     )
                    //     const thresholds = JSON.parse(
                    //       configData.thresholdsConfigurationAttributes,
                    //     )
                    //     const custAttr =
                    //       JSON.parse(configData.assetCustomAttributesMap) || []
                    //     custAttr.sort(sorting)
                    //     setAssetCustAttributes([])
                    //     console.log('custAttr', custAttr)
                    //     setAssetCustAttributes(custAttr)

                    //     thresholds.sort(sorting)
                    //     setThresholdsConfigurationAttributes([])
                    //     setThresholdsConfigurationAttributes(thresholds)
                    //     reportsAttributes.sort(sorting)
                    //     setAssetReportsAttributes([])
                    //     setAssetReportsAttributes(reportsAttributes)
                    //     alarmsAttributes.sort(sorting)
                    //     SetAssetAlarmsAttributes([])
                    //     SetAssetAlarmsAttributes(alarmsAttributes)
                    //     creationMap.sort(sorting)
                    //     setCreationData([])
                    //     setCreationData(creationMap)
                    //     setCountries()
                    //     devicesRefList.Devices.options[0] = new Option(
                    //       'select device',
                    //       -2,
                    //       false,
                    //       false,
                    //     )
                    //     allAssets.Devices.forEach((device, idx) => {
                    //       if (devicesRefList.Devices)
                    //         devicesRefList.Devices.options[idx + 1] = new Option(
                    //           device['device name'],
                    //           device['device name'],
                    //           false,
                    //           false,
                    //         )
                    //     })
                    //   })
                    // }}
                  >
                    <>
                      <strong>
                        <IntelMsg id="Asset Type" />
                      </strong>
                      <select
                        ref={(ref) => {
                          register(ref, {
                            validate: {
                              isValidSelect: (value) => value !== '-1',
                            },
                          })
                          assetsRefList['Asset Type'] = ref
                          setAssetRefList(assetsRefList)
                          devicesRefList['Asset Type'] = ref
                          setDeviceRefList(devicesRefList)
                          gatewayRefList['Asset Type'] = ref
                          setGatewayRefList(gatewayRefList)
                        }}
                        name="assetType"
                        onChange={(e) => {
                          console.log('asset type:', e.target.value)
                          setSelectedAssetType(e.target.value)
                        }}
                      >
                        <option value={-1}>Select</option>
                      </select>
                    </>
                  </FormField>
                  {/* {storageCreationData.map((rowData) => (
                  <Form.Group>
                    {rowData.data.map((columnData) => createColumn(columnData))}
                  </Form.Group>
                ))} */}
                  {/* <Divider horizontal>General Attributes</Divider> */}
                  {creationData
                    ? creationData.map((rowData) => (
                        <Form.Group>
                          {rowData.data.map((columnData) =>
                            createColumn(columnData),
                          )}
                        </Form.Group>
                      ))
                    : null}

                  {/* <Divider horizontal>Thresholds</Divider> */}
                  {/* {thresholdsConfigurationAttributes.map((rowInfo) => (
                  <Form.Group>{createColumn(rowInfo)}</Form.Group>
                ))} */}
                  {/* {assetCustAttributes.length > 0 ? (
                    <Divider horizontal>Custom Attributes</Divider>
                  ) : null} */}
                  {assetCustAttributes.map((row) => (
                    <Form.Group>
                      {row.data.map((col) => createColumn(col))}
                    </Form.Group>
                  ))}
                </>
              ) : null}
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              type="submit"
              disabled={disableSubmit}
              form="deviceAddForm"
              className={styles.positiveStatus}
            >
              <IntelMsg id="loginSubmitButton" />
            </Button>
            <Button
              className={styles.negativeStatus}
              onClick={() => {
                handleClose()
              }}
            >
              <IntelMsg id="closeBtn" />
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Asset" />}
        dialogContent={dialogContent}
      />
    </>
  )
}
AddAsset.propTypes = {
  setShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}
export default AddAsset
